import React, { Component,Fragment } from 'react';
import {  
  Grid,
} from '@material-ui/core';

import styled from 'styled-components';
import {
   createLoanGridLabel,
} from './QuoteComparisonGridElements';
import SecondaryButton from "components/Global/Buttons/SecondaryButton";
import LoanNotes from "components/Global/OptionsMenu/LoanTable/LoanNotes";

const NoteGrid = styled(Grid)`
  padding-left:24px;
  padding-right:52px;
`
const RightAlignedGridItem = styled(Grid)`
  text-align:right;
`
class Notes extends Component {
  state ={
    loanNotesState: {}
  }
  setLoanNotesState = (id,isOpen) => {
    const {loanNotesState} = this.state;
    let loanNotesStateCopy = {...loanNotesState};    
    this.hideAllNotes(id, loanNotesStateCopy)    
    if(!loanNotesStateCopy[id]){      
      loanNotesStateCopy[id] = {isOpen:false}
    }
    loanNotesStateCopy[id].isOpen = isOpen;      
    return loanNotesStateCopy;
  }

  hideAllNotes = (id, loanNotesState) => {    
    for( let loanState in loanNotesState){
      if (loanNotesState.hasOwnProperty(loanState)) {
        loanNotesState[loanState].isOpen = false;
      } 
    }
  }

  openLoanNotes = id => {
    let loanNotesStateCopy = this.setLoanNotesState(id, true);
    this.setState({
      loanNotesState:loanNotesStateCopy
    });
  }
  closeLoanNotes = id => {        
    let loanNotesStateCopy = this.setLoanNotesState(id, false);
    this.setState({
      loanNotesState:loanNotesStateCopy
    });
  }
  removeCombinedQuote = (loans) => {
    loans.splice(2,1); // Can only combine two loans so we know the third loan is the one to remove
  }
  render() {
    const { loans, isCombined } = this.props;    
    const noteLoans = [...loans];
    if(isCombined)
      this.removeCombinedQuote(noteLoans);
    const {loanNotesState} = this.state;    

    let gridCol;
    if (loans.length <= 2) {
      gridCol = 4;
    } else if (loans.length >= 6) {
      gridCol = 1;
    } else if (loans.length >= 3) {
      gridCol = 2;
    } else {
      gridCol = 3;
    }

    return (
      <NoteGrid container direction="row">
        {createLoanGridLabel("Notes")}
        {noteLoans.map(x => (
          <RightAlignedGridItem item xs={gridCol} key={x.loanId}>
          <SecondaryButton onClick={() => this.openLoanNotes(x.loanId)}>Show</SecondaryButton>
          <LoanNotes  
            loanId={x.loanId}
            isOpen={loanNotesState && loanNotesState[x.loanId] &&  loanNotesState[x.loanId].isOpen}
            openNotes={this.openLoanNotes}
            closeNotes={() => {
              if(loanNotesState && loanNotesState[x.loanId] &&  loanNotesState[x.loanId].isOpen)
                this.closeLoanNotes(x.loanId)
            }}
          />
          </RightAlignedGridItem>
      ))}
      </NoteGrid>
    )
  }
}

export default Notes;